import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
export type NerdTipProps = StructuredContentDocumentWithRenderer<{
  children: StructuredContentDocument;
}>;
export const NerdTip = t0 => {
  const $ = _c(7);
  const {
    props
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundColor: "yellows.lightest",
      borderTop: "4px solid",
      borderTopColor: "primary.main",
      padding: "2rem"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box display="flex" alignItems="center"><Typography fontSize="1.5rem" variant="text" paddingRight={2}>🤓</Typography><Typography variant="smallHeadline" letterSpacing=".005rem" fontWeight={500}>Nerdy Tip</Typography></Box>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      marginTop: 2
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== props.children) {
    t4 = renderStructuredContent(props.children);
    $[3] = props.children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <Box sx={t1}>{t2}<Box sx={t3}>{t4}</Box></Box>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};